import React, { useState } from "react";
import { updateReport } from "../../services/reportsService";
import { showPromiseToast } from "../../services/toastService";
import { FaTools, FaCheck, FaTimes, FaRedo } from "react-icons/fa";
import { formatDate } from "../../utils/dateUtils";
import ReportCloseModal from "../modals/ReportCloseModal";

export default function ReportsManager({ state, setState }) {
	const [selectedReport, setSelectedReport] = useState(null);
	const [response, setResponse] = useState("");
	const [activeTab, setActiveTab] = useState("In Attesa");

	// Dizionario per stato
	const stateDictionary = {
		"In Attesa": "bg-yellow-500 text-white px-2 py-1 rounded-full text-xs",
		"In Lavorazione": "bg-blue-500 text-white px-2 py-1 rounded-full text-xs",
		Risolto: "bg-green-500 text-white px-2 py-1 rounded-full text-xs",
		Ignorato: "bg-gray-500 text-white px-2 py-1 rounded-full text-xs",
	};

	function handleStatusChange(id, newStatus, response = null) {
		let obj = { state: newStatus };
		if (response) obj.response = response;
		showPromiseToast(updateReport(id, obj), {
			pending: "Aggiornamento dello stato in corso...",
			success: "Stato aggiornato con successo!",
		}).then(() => {
			setState(state.map((report) => (report.id === id ? { ...report, ...obj } : report)));
		});
	}

	const handleCloseReport = (sendResponse) => {
		handleStatusChange(selectedReport.id, "Risolto", sendResponse ? response : "");
		setSelectedReport(null);
		setResponse("");
	};

	const renderActions = (report) => {
		switch (report.state) {
			case "In Attesa":
				return (
					<div className="flex flex-col space-y-2">
						<button
							className="flex justify-center items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
							onClick={() => handleStatusChange(report.id, "In Lavorazione")}
						>
							<FaTools />
							Lavora
						</button>
						<button
							className="flex justify-center items-center gap-2 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
							onClick={() => handleStatusChange(report.id, "Ignorato")}
						>
							<FaTimes />
							Ignora
						</button>
					</div>
				);
			case "In Lavorazione":
				return (
					<div className="flex flex-col space-y-2">
						<button
							className="flex justify-center items-center gap-2 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
							onClick={() => setSelectedReport(report)}
						>
							<FaCheck />
							Risolto
						</button>
						<button
							className="flex justify-center items-center gap-2 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
							onClick={() => handleStatusChange(report.id, "Ignorato")}
						>
							<FaTimes />
							Ignora
						</button>
					</div>
				);
			case "Risolto":
			case "Ignorato":
				return (
					<div className="flex flex-col space-y-2">
						<button
							className="flex justify-center items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
							onClick={() => handleStatusChange(report.id, "In Lavorazione")}
						>
							<FaRedo />
							Riapri
						</button>
					</div>
				);
			default:
				return null;
		}
	};

	const renderReports = () => {
		const filteredReports = state.filter((report) => report.state === activeTab);
		return (
			<div className="space-y-4 my-4">
				{filteredReports.map((report) => (
					<div
						key={report.id}
						className="border border-gray-300 rounded p-4 grid grid-cols-1 md:grid-cols-[4fr_1fr] lg:grid-cols-[5fr_1fr] gap-4 items-center"
					>
						<div>
							<h2 className="text-lg font-semibold flex items-center gap-2">
								Segnalazione #{report.id}
								<span
									className={
										stateDictionary[report.state] ||
										"bg-gray-300 text-black px-2 py-1 rounded-full text-xs"
									}
								>
									{report.state}
								</span>
							</h2>
							<p className="text-gray-500 text-sm mt-1">
								Creata: <strong>{formatDate(report.created_at)}</strong>
							</p>
							<p className="text-gray-600 mt-2">{report.text}</p>
						</div>
						<div>{renderActions(report)}</div>
					</div>
				))}
			</div>
		);
	};

	// Conta i report per stato
	const countByState = (stateName) => state.filter((report) => report.state === stateName).length;

	return (
		<div className="p-6 bg-white rounded shadow-md">
			<h1 className="text-2xl font-bold mb-4">Gestione Segnalazioni</h1>

			{/* Tabs */}
			<div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
				{["In Attesa", "In Lavorazione", "Risolto", "Ignorato"].map((tab) => (
					<button
						key={tab}
						className={`px-4 py-2 rounded ${
							activeTab === tab
								? "bg-blue-500 text-white"
								: "bg-gray-200 text-gray-700 hover:bg-gray-300"
						}`}
						onClick={() => setActiveTab(tab)}
					>
						{tab} ({countByState(tab)})
					</button>
				))}
			</div>

			{/* Render reports for the active tab */}
			{renderReports()}

			{/* Modale per rispondere */}
			{selectedReport && (
				<ReportCloseModal
					report={selectedReport}
					response={response}
					setResponse={setResponse}
					onClose={() => setSelectedReport(null)}
					onSubmit={handleCloseReport}
				/>
			)}
		</div>
	);
}
